<template>
  <div>
    <div class="toolbar" style="background: whitesmoke;padding:3px">
      <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
        <div style="display:flex;flex-direction:row;justify-content:flex-start;">
          <button :class="{ 'is-active': isActive.bold() }" @click="commands.bold" >
            <font-awesome-icon :icon="['far', 'bold']"  />
          </button>
          <button :class="{ 'is-active': isActive.italic() }" @click="commands.italic" >
            <font-awesome-icon :icon="['far', 'italic']"  />
          </button>
          <button :class="{ 'is-active': isActive.underline() }" @click="commands.underline" >
            <font-awesome-icon :icon="['far', 'underline']" style="position:relative;top:1px" />
          </button>
          <button :class="{ 'is-active': isActive.strike() }" @click="commands.strike" >
            <font-awesome-icon :icon="['far', 'strikethrough']"  />
          </button>
          <button :class="{ 'is-active': isActive.heading( { level: 1 }) }" @click="commands.heading({ level: 1 })">
            <font-awesome-icon :icon="['far', 'h1']" />
          </button>
          <button :class="{ 'is-active': isActive.heading( { level: 2 }) }" @click="commands.heading({ level: 2 })">
            <font-awesome-icon :icon="['far', 'h2']" />
          </button>
          <!-- <button :class="{ 'is-active': isActive.heading( { level: 3 }) }" @click="commands.heading({ level: 3 })">
            <font-awesome-icon :icon="['far', 'h3']" />
          </button>
          <button :class="{ 'is-active': isActive.heading( { level: 4 }) }" @click="commands.heading({ level: 4 })">
            <font-awesome-icon :icon="['far', 'h4']" />
          </button> -->
          <button :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list" >
            <font-awesome-icon :icon="['far', 'list-ol']" />
          </button>
          <button :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list" >
            <font-awesome-icon :icon="['far', 'list-ul']" />
          </button>
          </div>
      </editor-menu-bar>
    </div>
    <div class="editor">
    <editor-content :editor="editor" style="border:3px solid whitesmoke;padding: 20px;" />
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  HorizontalRule,
  Link,
  Strike,
  Underline,
  History,
  Placeholder
} from 'tiptap-extensions'

export default {
  components: {
    EditorMenuBar,
    EditorContent,
  },
  props: {
    // value: {
    //   type: String,
    //   // default: '<h2>Notes</h2><p></p>'
    //   default: null
    // },
    value: {
      type: Object,
      // default: '<h2>Notes</h2><p></p>'
      default: null
    },
  },
  data() {
    return {
      initialValueSet: false,
      currentNoteId: String,
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History(),
          new Placeholder('hello world')
        ],
        // content: `
        //   <h2>Notes</h2>
        //   <p></p>
        // `,
      }),
    }
  },
  computed: {
    text() {
      return this.editor.getHTML()
    }
  },
  watch: {
    // value: {
    //   immediate: true,
    //   handler(newVal, oldVal) { 
    //     console.log('newVal', newVal)
    //     console.log('oldVal', oldVal)
    //     // It seems like the note content will always be initialized to <p></p>
    //     // We only replace the content if the original content is undefined/null or <p></p>
    //     if (!this.initialValueSet || oldVal == '<p></p>') {
    //       this.editor.setContent(newVal)
    //     }
    //     this.initialValueSet = true

    //     // need this since we are 
    //     // this.editor.setContent(newVal)
    //   }, 
    // },
    value: {
      immediate: true,
      handler(newVal, oldVal) { 
        // Only set value the first time we get a value from a different note
        if (newVal.noteId != this.currentNoteId) {
          this.editor.setContent(newVal.note)
          this.currentNoteId = newVal.noteId
        } else {
          // console.log('not changing')
        }
      }, 
    },
    text: {
      immediate: true, 
      handler(newVal, oldVal) { 
        if (newVal === undefined) {
          newVal = ''
        }
        this.$emit('input', newVal)
      }, 
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
*:focus {
    outline: none;
}

</style>

<style scoped>
button {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:30px;
    height:30px;
    border-radius: 3px;
    margin: 2px;
    /* border:1px solid gray; */
}

.is-active {
  background: lightgray
}
</style>